import React, { type ComponentProps } from 'react';
import { ScrollView, StyleSheet, View } from 'react-native';
import { type Container, theme, useResponsive } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const CustomizationSelectedIngredientsContainer = (
  props: CustomizationSelectedIngredientsContainerProps,
) => {
  const { children, style, wrapperStyle, ...restProps } = props;

  const { match } = useResponsive();

  // ─── Styles ──────────────────────────────────────────────────────────

  const outerContainerStyles = [
    styles.outerContainer,
    match([styles.outerContainerXS, styles.outerContainerSM]),
    wrapperStyle,
  ];

  const contentContainerStyles = [
    styles.contentContainer,
    match([styles.contentContainerXS]),
    style,
  ];

  // ─────────────────────────────────────────────────────────────────────

  return (
    <View style={outerContainerStyles} {...restProps}>
      <ScrollView contentContainerStyle={contentContainerStyles}>
        {children}
      </ScrollView>
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  outerContainer: {
    flex: 1,
  },
  outerContainerXS: {},
  outerContainerSM: {
    paddingHorizontal: theme.spacing['4'],
  },
  contentContainer: {
    rowGap: theme.spacing['4'],
  },
  contentContainerXS: {
    paddingBottom: theme.spacing['30'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type CustomizationSelectedIngredientsContainerProps = ComponentProps<
  typeof Container
>;
